export const site = {
  name: "General Applications",
  description:
    "General Applications designs and builds intelligent systems that connect reliable data, useful retrieval, dependable workflows, and clear operational oversight.",
  baseUrl: "https://generalapplications.com",
  ogImagePath: "/images/og-default.png",
  logoPath: "/android-chrome-512x512.png",
  tagline: "Make complicated systems useful.",
} as const;
